module.exports = __webpack_public_path__ + "img/pekara-glavni-meni.12a20307.png";